<template>
    <fieldset class="space-y-4">
        <slot name="legend" />
        <div :class="class" class="grid gap-6">
            <slot />
        </div>
    </fieldset>
</template>
<script setup>
const props = defineProps({
    class: {
        type: String,
        default: 'grid-cols-1'
    }
})
</script>
